import { render } from "./HiStageGroup.vue?vue&type=template&id=5d179089"
import script from "./HiStageGroup.vue?vue&type=script&lang=js"
export * from "./HiStageGroup.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__